import React from "react";
import { Modal } from "semantic-ui-react";
import "./BasicModal.scss";

export function BasicModal(props) {
  const { show, close, title, size, children, className } = props;

  const sizeValue = size ? size : "fullscreen";

  return (
    <Modal
      closeIcon
      open={show}
      onClose={close}
      size={sizeValue}
      closeOnDimmerClick={false}
      centered={true}
      className={`basic-modal${className ? ` ${className}` : ""}`}
      style={{ width: "700px", maxWidth: "80%" }}
    >
      {/* {title && <Modal.Header>{title}</Modal.Header>} */}
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  );
}

// BasicModal.defaultProps = {
//   size: "tiny",
// };
